// src/hooks/useLocationData.js
import { useState, useEffect } from 'react';
import { State, City } from 'country-state-city';

const useLocationData = (countryCode = 'GB') => {
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedState, setSelectedState] = useState('');
    const [selectedCity, setSelectedCity] = useState('');

    // Fetch states for the given country
    useEffect(() => {
        const fetchedStates = State.getStatesOfCountry(countryCode);
        const finalStates = fetchedStates.filter((state) => {
            const fetchedCities = City.getCitiesOfState(countryCode, state.isoCode);
            return fetchedCities.length
        }) 
        
        setStates(finalStates.map(c => {
            if(c.name === "North Yorkshire"){
                c.name = "Northern Ireland"
            }
            return c;
        }));
    }, [countryCode]);

    // Fetch cities when the selected state changes
    const handleStateChange = (stateCode) => {

        if (stateCode && stateCode != 'Non-UK') { 
            const fetchedCities = City.getCitiesOfState(countryCode, stateCode);
            // console.log(fetchedCities)
            setCities(fetchedCities.map(city => ({ value: city.name, label: city.name })));
            setSelectedCity('');
        } else {
            setCities([])
        }
        setSelectedState(stateCode)
        setSelectedCity('')
    };

    return {
        states,
        cities,
        selectedState,
        selectedCity,
        handleStateChange,
        setSelectedCity, // In case you want to manually set selected city
    };
};

export default useLocationData;